import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';


export class ConfirmationDialogData {
    public header: string;
    public message: string;
    public confirmBtnTxt: string;
    public cancelBtnTxt: string;
    public subMessage: string;
    public saveAndConfirmBtnTxt: string;

    constructor(header: string = '', message: string = '', confirmBtnTxt: string = 'OK', cancelBtnTxt?: string, subMessage?: string, saveAndConfirmBtnTxt?: string) {
        this.header = header;
        this. message = message;
        this.confirmBtnTxt = confirmBtnTxt;
        this.cancelBtnTxt = cancelBtnTxt;
        this.subMessage = subMessage;
        this.saveAndConfirmBtnTxt = saveAndConfirmBtnTxt;
    }
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: 'confirmation-dialog.html',
    styleUrls: ['./confirmation-dialog.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class ConfirmationDialogComponent {
    dialogRef = inject<MatDialogRef<ConfirmationDialogComponent>>(MatDialogRef);
    data = inject<ConfirmationDialogData>(MAT_DIALOG_DATA);


    constructor() {}

    public onNoClick(): void {
        this.dialogRef.close();
    }

    public onSaveAndConfirmClick(): void {
        this.dialogRef.close({ saveAndConfirm: true });                  
    }
}